import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hh-health-records-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './health-records-widget.component.html',
  styleUrls: ['./health-records-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthRecordsWidgetComponent {}
